import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService,MessageService} from 'primeng/api';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { GridService } from 'app/Shared/Services/grid.service';
import { UserService } from 'app/Shared/Services/user.service';
import { default as GridColumnsJSON } from 'app/Shared/Constant/Grid Column Names/CAT-FDID-Columns.json';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { map, Subscription } from 'rxjs';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { AddFDIDComponent } from "./add-fdid/add-fdid.component";
import { Table, TableModule } from 'primeng/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgClass, CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { QuickSearchComponent } from "../../../Shared/Component/quick-search/quick-search.component";
import { DrawerModule } from 'primeng/drawer';
import { EditFdidComponent } from './edit-fdid/edit-fdid.component';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu';
import { GridCommonService } from 'app/Shared/Services/grid-common.service';

@Component({
    selector: 'app-fdid-info',
    templateUrl: './fdid-info.component.html',
    styleUrls: ['./fdid-info.component.scss'],
    imports: [FilterPanelComponent, AddFDIDComponent, TableModule, MatProgressSpinnerModule,EditFdidComponent,ContextMenuModule,ConfirmDialogModule,
        CommonModule, ButtonModule, MatTooltipModule, DrawerModule, FormsModule, DialogModule, ToastModule, QuickSearchComponent]
})
export class FirmDesignatedIdComponent implements OnInit, OnDestroy {
  @ViewChild(('dt1')) dt1!: Table;
  @ViewChild('cm') contextMenuItems!: ContextMenu;
  [x: string]: any;
  GridColumns = GridColumnsJSON;
  public jsonDataset: any[];
  LastExecutionCATDate!: any[];
  ActiveSymbol: any;
  SymbolsArray: any = [];
  DefaultFilterArray: any = [];
  isLoadingResults = true;
  rowcount: any = 15;
  Limit: any = { 'Start': '', 'End': '' };
  totalRecords: any;

  startLimit: any = 0;
  endLimit!: number;
  
  public filterColumns: any = []
  public columns: any = [];
  public displayDialog: boolean;
  public fdidData: any = [];
  public fdidTypeList: any;
  public accountTypes: any;

  public roles: any;
  public addFDID: boolean;
  public editFDID: boolean;
  public viewFDID: boolean;
  public selectedFdid: any;
  public fdidColumns!: any[];
  public sortOptions: any;
  public isViewFDID: boolean;
  public selectedFDID: any;
  public _dataTable: any;
  public tbldatamsg = 'L o a d i n g . . . . .';
  public sortByValue: any;
  public subscription!: Subscription;
  pageNumber!: number;
  priviousStartLimit: any;
  checked:any;
  displaySideBar:any=false;
  isExportToJSON!: boolean;
  autoCopied:boolean=false;

  quickFilterArray:any;

  constructor(
    private urlsService: UrlsService,
    public userService: UserService,
    private sharedHttpClientService: SharedHttpClientService,
    private gridService: GridService,
    private emitterService: EmitterService,
    public constantService: ConstantService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    public commonColService:GridCommonService) {
    this.addFDID = false;
    this.viewFDID = false;
    this.editFDID = false;
    this.displaySideBar = false;
    this.displayDialog = false;
    this.jsonDataset = [];
    this.fdidTypeList = [];
    this.accountTypes = [];
  
    this.roles = [];
    this.getDropdownValues();
    this.selectedFdid = {};
    this.sortOptions = [];
    this.isViewFDID = false;
    this.sortByValue = {label: '', value: ''};

  }

  ngOnInit(): void {
    this.fdidColumns = this.gridService.getGridColumns(this.GridColumns);
    this.rowcount=this.constantService.DEFAULT_ROWSIZE;
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    this.defaultFilter();
    this.getColumns();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }

      this.sortOptions = [
        {label: 'Name', value: 'name'},
        {label: 'Account Number', value: 'accountNumber'},
        {label: 'Given Name', value: 'givenName'}
      ];
    });

    this.quickFilterArray = [
      {
        label: 'Account Number', columnname: 'tf.accountNumber', placeholder: 'Account Number',
        width: '', datatype: 'String', isLarge: true
      },
      {
        label: 'Given Name', columnname: 'tf.givenName', placeholder: 'Given Name',
        width: '', datatype: 'String'
      },
      {
        label: 'Generated FDID', columnname: 'tf.generatedFDID', placeholder: 'Generated FDID',
        width: '300', datatype: 'String', className:'', isLarge: true
      }
    ];
    this.commonColService.init(this.columns, 'Fdid-Info');
  }


  changePage(event:any) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;

    this.getData();
  }

  FilterEventClearSymbol(event: any) {
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount
  }


  
  FilterApplyFilterEvent(event:any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount
    this.getData();
  }

  GridResetSymbolEvent(event: any) {
    this.startLimit = 0;
    this.Limit.End = 200;
    this.Limit.Start = 0;
    this.Limit = { 'Start': this.startLimit, 'End': 200 };
    this.emitterService.ResetQuickFilterPanelEvent.emit('All');
  }

  GridChangeLimitEvent(event: any) {
    this.Limit = event;
    this.getData();
  }

  defaultFilter() {
    this.DefaultFilterArray = [
      {
        'isdefault': 'true', 'label': 'FDID Effective Date', 'columnname': 'tf.fdidEffectiveDate', 'filterby': 'IS', 'values': '',
        'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''
      },
      {
        'isdefault': 'true', 'label': 'Account Number', 'columnname': 'tf.accountNumber', 'filterby': 'IS', 'values': '',
        'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''
      },
      {
        'isdefault': 'true', 'label': 'Given Name', 'columnname': 'tf.givenName', 'filterby': 'IS', 'values': '',
        'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''
      },
      {
        'isdefault': 'true', 'label': 'Name', 'columnname': 'tf.name', 'filterby': 'IS', 'values': '',
        'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''
      },
      {
        'isdefault': 'true', 'label': 'Generated FDID', 'columnname': 'tf.generatedFDID', 'filterby': 'IS', 'values': '',
        'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''
      },
      {
        'isdefault': 'true', 'label': 'Received FDID', 'columnname': 'tf.receivedFDID', 'filterby': 'IS', 'values': '',
        'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''
      }
    ];
    this.getData();
  }

  public onClickAddFDID() {
      this.addFDID = true;
      this.displaySideBar = true;
  }


  closeAddFDID(isLoadData: boolean) {
    if(isLoadData) {
      this.getData();
    } 
    this.addFDID = false;
    this.displaySideBar = false;
  }


  getData() {
    this.isLoadingResults = true;
    this.gridService.getData(
      APIURL.CAT_FDID,
      this.DefaultFilterArray,
      this.Limit,
      '',
      'FDID-Info'
    ).subscribe({
      next: (Element:any) => {
        this.isLoadingResults = false;
        let jsondataset: any;
        jsondataset = Element;
        this.fdidData = jsondataset.Data;
        this.totalRecords = jsondataset.totalCount;
      },
      error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
      }
      });
  }

  public getColumns() {
    let column: any;
    column = this.GridColumns;
    if (column != null || column !== undefined) {
      this.columns = this.gridService.getGridColumns(column);
      this.filterColumns = this.columns;
    }
  }

  public onRowSelect(value: any, row:any) {
    this.selectedFDID = row;
    this.viewFDID = false;
    this.editFDID = false;
    if (value === 'View') {
      this.viewFDID = true;
      this.displaySideBar = true;
    } else if (value === 'Edit') {
      this.editFDID = true;
      this.displaySideBar = true;
    } else if (value === 'Delete') {
      // Function to delete record
      this.fdidData.splice(row, 1);
    }
  }

  public getDropdownValues() {
    this.fdidTypeList = [
      { id: 1, fdidType: 'CUSTOMER ACCOUNT' },
      { id: 2, fdidType: 'TRADING ACCOUNT' }
    ];
    this.accountTypes = [
      { id: 1, accountType: 'Natural Person' },
      { id: 2, accountType: 'Legal Entity' }
    ];
    
    this.roles = [
      { id: 1, role: 'Account Holder' },
      { id: 2, role: 'Authorised Trader' },
      { id: 3, role: 'Other' }
    ];
  }

  public saveFDIDDetails() {

  }

  public saveCustomerDetails(customer: any) {
    if (!this.fdidData.includes(customer)) {
      this.fdidData.push(customer);
    }
  }

  public onClickGetFDIDDetails(row:any) {
    this.selectedFDID = row;
    if (this.Limit.End === 0 && this.Limit.End === '' && this.Limit.Start === '') {
      this.gridService.getGridRowsCount();
      this.Limit.End = this.rowcount;
      this.Limit.Start = 0;
    }
    let Data;
    Data = {
        'data': this.DefaultFilterArray,
        'mpid': this.userService.getActiveMPID(),
        'fdid': this.selectedFDID.fdid ? this.selectedFdid.fdid : this.selectedFDID.receivedFDID,
        'startLimit': this.Limit.Start,
        'endLimit': this.Limit.End,
        'pageName': 'Fdid-Info',
        'eventType': ''
    };
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.GET_FDID_DETAILS), Data)
        .pipe(map((response: Response) => {
            return response;
        })).subscribe({
          next: (response: any) => {
            this.isLoadingResults = false;
            let data:any=response;
            this.selectedFDID = data;
            this.isViewFDID = true;
          },  
          error: (err: HttpErrorResponse) => {
            this.isLoadingResults = false;
          }
        });
  }

  public onClickCancelFDID() {
    this.editFDID = false;
    this.viewFDID = false;
    this.displaySideBar = false;
    this.selectedFDID = {};
  }

  public onCheckConfirm(checked:any) {
    if (checked) {
      this.confirmationService.confirm({
          message: 'Are you sure want to change Received FDID?',
          accept: () => {
              // logic to perform a confirmation
          }
      });
    }
  }

  exportToCSV() {
    if(this.userService.enableFileExport()){
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    this.isExportToJSON = true;
    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });

    const filename='RSMS_FDID_' + this.userService.getyyyyMMddDateFormate(new Date());
    this.gridService.getData(
      APIURL.CAT_FDID,
      this.DefaultFilterArray,
      this.Limit,
      '',
      'FDID-Info'
    ).subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
        let data = dataset.Data;
        if (data.length > 0) {
          const options = {
            fieldSeparator: ',',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title:filename,
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            filename: filename
          };
          const csv = generateCsv(options)(this.constantService.getExportData(data,this.GridColumns));
          const blob = asBlob(options)(csv);
          saveAs(blob, filename);
          this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'No data found',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }
      },
      error: (e) => {
          console.error(e);
      }
    });
    this.isExportToJSON = false;
  }
}

  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }

  updateDefaultArray($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    this.dt1.first = 1;
    this.getData();
  }

  clearQuickSearch($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    this.dt1.first = 1;
    this.getData();
  }
  public onClickEditFDID(rowData:any){
    this.selectedFDID = rowData;
    this.editFDID = true;
    this.displaySideBar = true
    this.autoCopied = !! rowData.generatedFDID;
  }
  refreshFDIDData(value:boolean){
    if(value){
      this.getData();
      this.editFDID = false;
    }
  }
   closeEditFDID(isLoadData: boolean) {
    this.editFDID = isLoadData;
  }

  onDelete(ri:any, selectedRow:any) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"fdid-confirm-dialog-button",
      rejectButtonStyleClass:"fdid-confirm-dialog-button",
      accept: () => {
        this.isLoadingResults = true;
        let payload = {
        "CATReporterIMID": this.userService.getActiveMPID(),
        "givenName": selectedRow["givenName"],
        "UpdatedUser": this.userService.getUserFirstName(),
        "id":selectedRow["id"],
        "generatedFDID": selectedRow["generatedFDID"],
        "reporDate": selectedRow["createdDate"]
        }
        this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.CAT_FDID_Delete), payload)
          .pipe(map((response: Response) => {
            return response;
          }))
          .subscribe({
            next: (data: any) => {
              this.isLoadingResults = false;
              if (data.status) {
                this.getData();
                this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Record deleted' });
                this.messageService.add({ severity: 'success', summary: 'Update Success Message', detail: data.data });
              } else {
                this.messageService.add({ severity: 'error', summary: 'Update Success Message', detail: data.data });
              }
            },    
            error: (err: HttpErrorResponse) => {
              this.isLoadingResults = false;
            }
          });  
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'Action cancelled' });
      }
    });
  }
 
}


